import { style } from '@vanilla-extract/css';

export const selectMultipleFilterWrapperClass = style({
  width: '100%',
});

export const optionRowClass = style({
  alignItems: 'center',
});
